/* import __COLOCATED_TEMPLATE__ from './settling-panel.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { alias } from '@ember/object/computed';
import PrettyNum from '../utils/pretty-num-wrapper';
import { computed, action } from '@ember/object';

export default class SettlingPanel extends Component {
    tagName = '';

    @service('data') model;
    @service tabService;
    @service ltSpice;
    @service selectionData;
    @service errorHandling;
    @service intl;

    @alias('errorHandling.bwWarnings') bwWarnings;

    menuId = 'settling-tabs';

    updateAppData = () => {};

    @computed('selectionData.selectedAdc.{partCore,cadc}') get rcFilterBandwidthBodyArgs() {
        return {
            selectedAdc: this.selectionData.selectedAdc.partCore,
            cadc: PrettyNum.eng3(this.selectionData.selectedAdc.cadc),
            cadcUom: this.intl.t('units.f'),
        };
    }

    // {{pretty-num value=this.model.samplePeriod uom=(t "units.s") separatedUnit=true}}
    @computed('model.samplePeriod') get prettySamplePeriod() {
        return `${PrettyNum.eng3(this.model.samplePeriod, { separatedUnit: true })}${this.intl.t('units.s')}`;
    }

    // {{pretty-num value=this.model.inputSettlingArrays.conversionTime uom=(t "units.s") separatedUnit=true}}
    @computed('model.inputSettlingArrays.conversionTime') get prettyConversionTime() {
        return `${PrettyNum.eng3(this.model.inputSettlingArrays.conversionTime, { separatedUnit: true })}${this.intl.t(
            'units.s',
        )}`;
    }

    // {{pretty-num value=this.model.inputSettlingArrays.acquisitionTime uom=(t "units.s") separatedUnit=true}}
    @computed('model.inputSettlingArrays.acquisitionTime') get prettyAcquisitionTime() {
        return `${PrettyNum.eng3(this.model.inputSettlingArrays.acquisitionTime, { separatedUnit: true })}${this.intl.t(
            'units.s',
        )}`;
    }

    // {{pretty-num value=this.model.filterBandwidth uom=(t "units.hz") separatedUnit=true}}
    @computed('model.filterBandwidth') get prettyFilterBandwidth() {
        return `${PrettyNum.eng3(this.model.filterBandwidth, { separatedUnit: true })}${this.intl.t('units.hz')}`;
    }

    // {{pretty-num value=this.model.oneLsb uom=(t "units.v") separatedUnit=true}}
    @computed('model.oneLsb') get prettyOneLsb() {
        return `${PrettyNum.eng3(this.model.oneLsb, { separatedUnit: true })}${this.intl.t('units.v')}`;
    }

    @computed('selectionData.selectedAdc.settlingPanelMessageIntl') get settlingPanelMessage() {
        let selectedAdc = this.selectionData.selectedAdc;
        return selectedAdc.settlingPanelMessageIntl
            ? this.intl.t(`messages.${selectedAdc.settlingPanelMessageIntl}`, { adc: selectedAdc.partCore })
            : null;
    }

    @action downloadSimulation() {
        this.ltSpice.downloadSimulation();
    }
}
